import { t } from "i18next";
import React from "react";
import { ConnectText, GiveIconHeader, GiveIconHeaderMbl } from "../../atoms/Header";
import GiftIconGrey from "../../../images/gift_icon_grey.svg";
import GiftIconOrange from "../../../images/gift_icon_orange.svg";
import GiftIconWhite from "../../../images/heart_icon_white.svg";
import { useNavigate } from "react-router-dom";

const GiveIcon=(props)=>{
    const navigate = useNavigate();
    const navToSendAGift=()=>{
        props?.checkSponsorship !== undefined && props?.checkSponsorship();
        if(window.location.pathname.includes("/pastSponsoredChild")){
            props?.onClick();
        }else{
            navigate(`/sendAGift/${props?.selectedChild}`,{state:{childCode:props?.selectedChild,suggestions:props?.suggestions,navigateFrom:props?.navigateFrom}})
        }
    }

    return(<>
     {
     <GiveIconHeader station={!props.community} onClick={navToSendAGift} connect>
            <ConnectText>{t("DT_WVM_GIV_HEAD_00007_Give")}</ConnectText>
        </GiveIconHeader>
       }
        </>
    )
}

export function GiveIconMbl(props){
    const navigate = useNavigate();
    const navToSendAGift=()=>{
        if(window.location.href.includes("/home")){
            navigate("/donate", {state:{navigateFrom: "home"}})
        }
        else{
        navigate(`/sendAGift/${(props?.selectedChild)}`,{state:{childCode:props?.selectedChild,suggestions:props?.suggestions}})
        }
    }

    return(<>
     {
     props.community?
     <GiveIconHeaderMbl station={!props.community} onClick={navToSendAGift}>
            <img src={GiftIconWhite} alt= ""/>
            <ConnectText community={props?.community}>{t("DT_WVM_GIV_HEAD_00007_Give")}</ConnectText>
        </GiveIconHeaderMbl>
        :<GiveIconHeaderMbl onClick={navToSendAGift}>
        {window.location.href.includes("sendAGift") ? <img src={GiftIconOrange} alt= ""/> : <img src={GiftIconGrey} alt= ""/>}
        <ConnectText community={props?.community}>{t("DT_WVM_GIV_HEAD_00007_Give")}</ConnectText>
       </GiveIconHeaderMbl>
       }
        </>
    )
}

export default  GiveIcon;